import React, { useEffect } from "react";
import { RouterProvider } from "react-router";
import { HelmetProvider } from "react-helmet-async";

import ErrorBoundary from "./components/ErrorBoundary";
import router from "./router";
import { preRenderQueries } from "@/services/ApiOps";

const App: React.FC = () => {
  useEffect(() => {
    preRenderQueries();
  }, []);
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </ErrorBoundary>
  );
};

export default App;
